var _g, _path, _path2, _g2, _mask, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRunningNow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 74,
  height: 78,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#running_now_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 42.252,
  height: 46.168,
  x: 15.49,
  y: 12.217,
  fill: "url(#running_now_svg__b)",
  rx: 3.6
}), /*#__PURE__*/React.createElement("rect", {
  width: 44.652,
  height: 48.568,
  x: 14.29,
  y: 11.017,
  stroke: "#fff",
  strokeWidth: 2.4,
  rx: 4.801
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2.371,
  d: "M37.53 37.106v-1.62a2 2 0 0 1 .953-1.704l6.43-3.95a2 2 0 0 0 .953-1.704v-5.574a2 2 0 0 0-2-2H27.123a2 2 0 0 0-2 2.007l.019 5.572a2 2 0 0 0 .953 1.697l6.433 3.952a2 2 0 0 1 .953 1.704v1.62"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2.371,
  d: "M37.53 34.812v1.62a2 2 0 0 0 .953 1.704l6.43 3.95a2 2 0 0 1 .953 1.704v5.574a2 2 0 0 1-2 2H27.123a2 2 0 0 1-2-2.007l.019-5.572a2 2 0 0 1 .953-1.697l6.433-3.952a2 2 0 0 0 .953-1.704v-1.62"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#running_now_svg__c)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 45.866,
  cy: 41.311,
  r: 6.01,
  fill: "url(#running_now_svg__d)",
  stroke: "#867AF2",
  strokeWidth: 1.801
}))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "running_now_svg__e",
  width: 5,
  height: 7,
  x: 43.315,
  y: 38.079,
  fill: "#000",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M43.315 38.079h5v7h-5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.819 41.526c0-1.287.613-2.636 2.046-2.636s2.046 1.349 2.046 2.636-.613 2.645-2.046 2.645-2.047-1.357-2.047-2.645m3.18 0c0-.973-.299-1.84-1.134-1.84-.836 0-1.134.867-1.134 1.84s.298 1.847 1.134 1.847 1.134-.873 1.134-1.847"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#867AF2",
  d: "M43.819 41.526c0-1.287.613-2.636 2.046-2.636s2.046 1.349 2.046 2.636-.613 2.645-2.046 2.645-2.047-1.357-2.047-2.645m3.18 0c0-.973-.299-1.84-1.134-1.84-.836 0-1.134.867-1.134 1.84s.298 1.847 1.134 1.847 1.134-.873 1.134-1.847"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#867AF2",
  d: "M43.819 41.526h.4c0-.588.141-1.164.418-1.579.266-.399.66-.657 1.228-.657v-.8c-.864 0-1.495.416-1.893 1.013-.388.581-.553 1.324-.553 2.023zm2.046-2.636v.4c.569 0 .962.258 1.228.657.277.415.418.99.418 1.58h.8c0-.7-.165-1.443-.553-2.024-.398-.597-1.029-1.013-1.893-1.013zm2.046 2.636h-.4c0 .589-.141 1.167-.419 1.584-.266.401-.66.66-1.227.66v.8c.865 0 1.496-.419 1.894-1.017.387-.583.552-1.328.552-2.027zm-2.046 2.645v-.4c-.568 0-.96-.26-1.228-.661-.277-.417-.419-.995-.419-1.584h-.8c0 .7.166 1.444.553 2.027.398.599 1.029 1.018 1.894 1.018zm1.134-2.645h.4c0-.516-.077-1.051-.3-1.472-.236-.444-.642-.767-1.234-.767v.8c.243 0 .404.11.527.342.136.256.207.64.207 1.097zm-1.134-1.84v-.4c-.592 0-.999.324-1.234.768-.223.42-.3.956-.3 1.472h.8c0-.456.071-.841.207-1.097.123-.232.283-.342.527-.342zm-1.134 1.84h-.4c0 .517.077 1.053.3 1.475.234.446.64.773 1.234.773v-.8c-.242 0-.403-.11-.527-.345-.136-.259-.207-.646-.207-1.103zm1.134 1.847v.4c.593 0 1-.326 1.234-.772.223-.422.3-.958.3-1.475h-.8c0 .457-.071.844-.207 1.102-.124.235-.285.346-.527.346z",
  mask: "url(#running_now_svg__e)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "running_now_svg__b",
  x1: 15.49,
  x2: 57.742,
  y1: 35.301,
  y2: 35.301,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5DBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EDFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "running_now_svg__d",
  x1: 39.856,
  x2: 51.875,
  y1: 41.311,
  y2: 41.311,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5DBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EDFF"
})), /*#__PURE__*/React.createElement("filter", {
  id: "running_now_svg__a",
  width: 73.231,
  height: 77.147,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.272
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.545
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.0352941 0 0 0 0 0.509804 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_25_1003"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_25_1003",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "running_now_svg__c",
  width: 21.023,
  height: 21.023,
  x: 35.354,
  y: 32.6,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.801
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.801
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_25_1003"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_25_1003",
  result: "shape"
})))));
export default SvgRunningNow;